export default __webpack_public_path__ + "static/media/cargoIcon.013b3ed8.svg";